import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('', 'resource');

tbl.add(new Xtc('type', 'Type'))
tbl.add(new Xtc('desc', 'Description'))
tbl.add(new Xtc('matter', 'Matter'))
tbl.add(new Xtc('shared-to', 'Shared To'))
tbl.add(new Xtc('shared-by', 'Shared By'))
tbl.add(new Xtc('date', 'Date'))

export default tbl;

